import React, { useEffect, useState } from 'react';
import { Chart } from 'react-google-charts';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, query, getDocs } from 'firebase/firestore';

function MyChartComponent({ theme }) {
  const [rezultateInterogare, setRezultateInterogare] = useState([]);
  const [titluri, setTitluri] = useState([]);

  useEffect(() => {
    // Configurație Firebase
    const firebaseConfig = {
      apiKey: "AIzaSyD0xuFqfhzDpUclEwvWe9K2YRVJg70UCxw",
      authDomain: "vest-truck.firebaseapp.com",
      projectId: "vest-truck",
      storageBucket: "vest-truck.firebasestorage.app",
      messagingSenderId: "564041001310",
      appId: "1:564041001310:web:56eed2f1c23f1ce86b87cf"
    };
    const firebaseApp = initializeApp(firebaseConfig);

    // Obține o referință la colecția din Firestore
    const db = getFirestore(firebaseApp);

    const fetchData = async () => {
      try {
        const postCollectionRef = collection(db, 'post');
        const querySnapshot = await getDocs(postCollectionRef);

        // Obține toate titlurile unice din colecția 'post'
        const titluriSet = new Set();
        querySnapshot.forEach(doc => {
          titluriSet.add(doc.data().titlu);
        });

        // Convertește Set-ul într-un array
        const titluriArray = Array.from(titluriSet);
        setTitluri(titluriArray);

        // Numără câte posturi sunt pentru fiecare titlu
        const rezultateInterogare = {};
        for (const titlu of titluriArray) {
          const count = querySnapshot.docs.filter(doc => doc.data().titlu === titlu).length;
          rezultateInterogare[titlu] = count;
        }

        setRezultateInterogare(rezultateInterogare);
      } catch (error) {
        console.error("Eroare la obținerea documentelor: ", error);
      }
    };

    fetchData();
  }, []);

  const textFillColor = theme === 'dark' ? '#ffffff' : '#000000';

  return (
    <div>
      <Chart
        chartType="PieChart"
        data={[
          ['Titlu', 'Count'],
          ...titluri.map((titlu) => [titlu, rezultateInterogare[titlu] || 0])
        ]}
        options={{
          is3D: true,
          backgroundColor: theme === 'dark' ? '#212529' : '#f7f7f7',
          legend: {
            textStyle: {
              color: textFillColor
            }
          },
          chartArea: {
            textStyle: {
              color: textFillColor
            }
          }
        }}
        graph_id="piechart_3d"
        width={'100%'}
        height={'400px'}
      />
    </div>
  );
}

export default MyChartComponent;
